export const colors = {
  // Identidad de marca y roles
  ppalStudent: '#FFDC50',
  ppalProfessor: '#08A8D2',
  ppalAdmin: '#BDDDEB',
  secondary: '#BDDDEB',
  brandBlue: '#08A8D2',
  brandBlueDark: '#087E9D',
  brandBlueLight: '#E8F8FC',
  brandYellow: '#FFDC50',
  brandYellowSoft: '#FFE688',
  brandYellowDark: '#D7AD05',
  brandYellowLight: '#FFF8D9',
  brandCoral: '#F47C6C',
  brandCoralVivid: '#F97052',
  brandCoralDark: '#C95245',
  brandCoralLight: '#FFF0ED',

  // Texto
  textPrimary: 'var(--redesign-text-primary, #0A0A18)',
  textSecondary: 'var(--redesign-text-secondary, #54576B)',
  textMuted: 'var(--redesign-text-muted, #74778B)',
  textOnColor: '#FFFFFF',

  // Fondos y superficies
  background: 'var(--redesign-background-canvas, #F7F8FA)',
  backgroundLight: 'var(--redesign-background-subtle, #FBFCFD)',
  backgroundGrey: 'var(--redesign-background-muted, #F0F2F5)',
  surface: 'var(--redesign-surface, #FFFFFF)',
  surfaceElevated: 'var(--redesign-surface-elevated, #FFFFFF)',

  // Bordes
  border: 'var(--redesign-border, #DDE1E7)',
  borderStrong: 'var(--redesign-border-strong, #B9C0CB)',
  borderPrimary: '#08A8D2',

  // Estados semánticos
  success: '#248A5B',
  successLight: '#E8F7EF',
  error: '#D84A4A',
  errorLight: '#FDECEC',
  warning: '#FFDC50',
  warningLight: '#FFF8D9',
  info: '#087E9D',
  infoLight: '#E8F8FC',

  // Neutros puros
  white: '#FFFFFF',
  black: '#000000',
} as const

export type ColorKeys = keyof typeof colors
